<template>
	<div class="container-fluid bg-white">
		<employees-toolbar>
			<router-link to="/employee/new" class="btn btn-success">
				<i class="fa fa-plus"></i>
				New Employee
			</router-link>

			<search-bar 
				placeholder="Search Employees..." 
				v-on:submit="searchSubmit"
				v-on:clearSearch="searchSubmit">
			</search-bar>
		</employees-toolbar>

		<onboarding-card title="Invite employees" name="Employees" setting-key="employeesInvited">
			<p>You can invite employees to join {{$store.appName}} and get connected to your company.</p>
		</onboarding-card>

		<table-list
			key="employeeList"
			:loading="loading"
			:records="mutatedEmployees"
			:mobile-breakpoint="$store.tableListMobileBreakpoint"
			:fields="tableFields"
			record-name="Employee"
			:other-buttons="tableButtons"
			id-field="slug"
			:sortable="true"
			:collapse-buttons="isFullTable"
			:total-paginated-records="userCount"
			v-on:otherButtonClick="otherButtonClick">

      		<!-- Table Tabs -->
			<div style="display: inline-block;">
				<field 
					:params="{type:'btn-group',tabStyling:true,buttons:[
						{text:'Active',value:'active'},
						{text:'Invites', value:'invites'},
						{text:'All',value:'all'},
					]}"
					v-model="tableTab"
					v-on:change="fetchTableData">
				</field>
			</div>

			<div class="buttons float-right mr-2 ml-4">

				<button v-if="qboIsActive" class="btn btn-light" title="This will push your employee list to Quickbooks Online" v-on:click="syncQBOModal.visible = true">
					<i class="fa fa-cloud-upload-alt"></i>
					Sync to QBO...
				</button>

				<button class="btn btn-light" v-on:click="showUserClockedInMap">
					<i class="fa fa-map"></i>
					Map of Clocked in Employees
				</button>
			</div>


			<!-- Inline blocks (invited, active, total) -->
			<div class="d-inline-block float-right mt-1">

				<info-box
					class="d-inline-block mr-1"
					label="Active Employees"
					:value="activeEmployeeCount">
				</info-box>

				<info-box
					class="d-inline-block mr-1"
					label="Invited Employees"
					:value="invitedEmployeeCount">
				</info-box>

				<info-box
					class="d-inline-block mr-1"
					label="Total Employees"
					:value="activeEmployeeCount + invitedEmployeeCount">
				</info-box>
			</div>

		</table-list>

		<pagination v-if="pages > 1" :current-page="page" :pages="pages" v-on:pageChange="pageChange"></pagination>

		<new-message-thread 
			v-if="newThreadModalVisible" 
			:visible="newThreadModalVisible"
			v-on:closeModal="newThreadModalVisible = false"
			:copied-thread="preFilledThread">
		</new-message-thread>

	<!-- "Map of Clocked in Employees" popup modal -->
		<modal-dialog
			:modal-visible="mapModalVisible"
			:title="'Clocked in Employees: '+clockedInUsers.length"
			:submit-visible="false"
			cancel-button-text="Close"
			modal-size="modal-lg"
			v-on:closeModal="mapModalVisible = false">

			<div v-if="mapModalVisible && !mapModalWorking">

				<vue-map
					:markers="userMarkers"
					:center="mapCenter"
					:zoom="7"
					map-size="map-md">
				</vue-map>
			</div>
			<div v-else class="text-center">
				<div><i class="fa fa-spin fa-spinner"></i></div>
				<div>Loading Employee Positions</div>
			</div>

		</modal-dialog>

	<!-- "Sync to QBO" popup modal -->
		<modal-dialog
			:modal-visible="syncQBOModal.visible"
			title="Sync Employees to Quickbooks Online"
			:working="syncQBOModal.working"
			v-on:closeModal="syncQBOModal.visible = false"
			v-on:confirm="syncQBOData"
			confirm-button-text="Sync">

			<p v-if="syncQBOModal.working" class="text-center">
				Syncing... this may take a minute or two
				<spinner :inline="true"></spinner>
			</p>
			<template v-else>
				<p>If matching employees are found:</p>

				<label>
					<input type="checkbox" v-model="syncQBOModal.overwriteDetails" value="1">
					Update Quickbooks employee data with {{$store.appName}} data
				</label>
			</template>
			

		</modal-dialog>

	</div>
</template>

<script>
import EmployeesToolbar from "@/pages/employees/EmployeesToolbar"

import TableList from "../../components/TableList"
import Field from "../../components/Field"
import NewMessageThread from "../../components/super_components/NewMessageThread"
import ModalDialog from "@/components/ModalDialog"
import VueMap from "@/components/VueMap"
import Pagination from "@/components/Pagination"
import SearchBar from "@/components/SearchBar"
import Spinner from "@/components/Spinner"

import OnboardingCard from "@/components/OnboardingCard"
import InfoBox from "@/components/InfoBox"

export default {

	name: 'EmployeeList',
	components: {
		TableList,
		NewMessageThread,
		Field,
		ModalDialog,
		VueMap,
		Pagination,
		EmployeesToolbar,
		SearchBar,
		Spinner,
		OnboardingCard,
	InfoBox
	},
	data() {
		return {
			newThreadModalVisible: false,
			tableTab: 'active',
			preFilledThread: {},
			page: 1,
			pages: 0,
			userCount: 0,
			clockedInUsers: [],
	  invitesFields: [
		{
		  label: "Name",
		  key: "fullName",
		  type: "link"
		},
		{
		  label: "Email",
		  key: "linkedEmail",
		  showOnMobile: false
		},
		{
		  label: "Phone",
		  key: "linkedPhone",
		  showOnMobile: false
		}
	  ],
			buttons: [
				{
					class: "btn-light",
					text: "Edit Details",
					link: "/employee/{?}/profile",
					icon: "fa-pencil-alt",

				},
				{
					class: "btn-light",
					text: "Expenses",
					link: "/employee/{?}/expenses",
					icon: "fa-receipt",
					modulePermRequired: "Expenses"
				},
				{
					class: "btn-light",
					text: "Time Logs",
					link: "/employee/{?}/time-logs",
					icon: "fa-clock",
					modulePermRequired: "TimeLogs"
				},
				{
					class: "btn-light",
					click: "mailUser",
					icon: "fa-envelope",
					text: "Message"
				},
				{
					class: "bg-success text-white",
					click: "phoneUser",
					icon: "fa-phone",
					title: "Call user",
					text: "Call"
				},
				{
					class: "btn-light",
					click: "resendInvite",
					icon: "fa-paper-plane",
					title: "Resend invite",
					text: "Resend Invite",
					condition: ["clockStatus","Invited"]
				}
			],
			loading: true,
			mapModalVisible: false,
			mapModalWorking: false,
			syncQBOModal: {
				visible: false,
				overwriteDetails: true,
				working: false
			},
			userInclude: [
				{model:"UserPermission",fields:["id","slug","role_type","is_inactive"]},
				{model: "EmployeeClassification",fields: ["title"]},
				{
					model: "ScheduleEvent",
					filters: [
						['start >=',this.moment().format("YYYY-MM-DD")],
						['start <',this.moment().format("YYYY-MM-DD 23:59:59")]
					],
					fields: ["is_sickday","is_vacation","title","start","duration_hrs"]
				}
				//{model: "OpenTimeLog",fields:["id","slug","lat","long","time_in"]}
			],
			userFields: ["id","slug","first_name","last_name","email","phone","phone_mobile","clocked_in","last_active","invite_accepted","emergency_contact_name","emergency_contact_phone"],

	  invitedInclude: [
		{
		  model: "User",
		  fields: ["slug","first_name","last_name","email","phone","phone_mobile"]
		}
	  ],
	  invitedFields: ["invite_accepted", "invite_declined", "is_inactive"],
	  invitedFilters: [
		["invite_accepted", 0],
		["invite_declined", 0],
		["is_inactive", 0]
	  ],
	  isFullTable: true,
	  activeEmployeeCount: 0,
	  invitedEmployeeCount: 0
		}
	},
	watch: {
		'$store.company'() {
			this.$forceUpdate()
		}
	},
	computed: {
		userMarkers() {
		  // Used By: "Map of Clocked in Employees" Modal
			let vm = this

			let markers = this.clockedInUsers.filter(user => "OpenTimeLog" in user && user.OpenTimeLog).map(user => {

				let jobLabel = "Project #"
				let jobKey = "Job"
				if (user.OpenTimeLog.service_id > 0) {
					jobKey = "Service"
					jobLabel = "Service #"
				}

				return {
					lat: +user.OpenTimeLog.lat,
					lng: +user.OpenTimeLog.long,
					//icon:  window.apiRoot+"resources/icons/hardhat_36_point.png",
					infoWindowText: user.first_name+" "+user.last_name+" since "+vm.formatDateTimeToLocal(user.OpenTimeLog.time_in,'month-day-time')+" on <a href='/service/" + user.OpenTimeLog[jobKey].slug + "/dashboard'>"+jobLabel+user.OpenTimeLog[jobKey].job_num+"</a>"
				}
			})

			return markers
		},
		mapCenter() {
			if ("lat" in this.$store.company && this.$store.company.lat && "long" in this.$store.company && this.$store.company.long)
				// Used By: "Map of Clocked in Employees" Modal
				return {
					lat: parseFloat(this.$store.company.lat),
					lng: parseFloat(this.$store.company.long)
				}
			else 
				return { //centered on toronto
					lat: 43.65,
					lng: -79.3
				}
		},
		mutatedEmployees() {
		  // Used By:  Employee Table
			let vm = this

			let employees = this.$store.employees.map(item => {

				item.isOnline = ""

				let lastActiveLocal = ""
				if (item.last_active)
					lastActiveLocal = vm.moment.utc(item.last_active).local().format("YYYY-MM-DD HH:mm:ss")

				if (this.isOnline(lastActiveLocal,120))
					item.isOnline = "<i class='fa fa-circle online-circle' title='Was active on "+vm.$store.appName+" recently'></i>"

				item.fullName = {}
				item.fullName.text = item.first_name + " "+ item.last_name
				item.fullName.link = "/employee/"+item.slug+"/profile"

				item.emergencyContactDetails = ""
				if (item.emergency_contact_name && item.emergency_contact_phone)
					item.emergencyContactDetails = item.emergency_contact_name+", "+item.emergency_contact_phone

				// Invite accepted? (ignored in invites tab)
				if (item.invite_accepted == 1) {
					if (item.clocked_in == 1)
						item.clockStatus = "<i class='fa fa-clock fa-2x' style='color:var(--brand-primary-color-faded);'></i>"
					else {
						let isSick, isOnVacation

						if ("ScheduleEvent" in item && item.ScheduleEvent.length > 0) {
							//check to see if there is a sick or vacation event schedule at this time

							item.ScheduleEvent.forEach(event => {
								let eventStart = vm.moment(event.start)
								let eventEnd = vm.moment(event.start)
								
								if (parseFloat(event.duration_hrs) > 0)
									eventEnd.add(parseFloat(event.duration_hrs),"hours")
								else
									eventEnd.endOf('day')

								if (eventStart.isBefore(vm.moment()) && eventEnd.isAfter(vm.moment())) {

									if (event.is_vacation == 1)
										isOnVacation = true

									if (event.is_sickday == 1)
										isSick = true
								}
							})

							if (isSick)
								item.clockStatus = "<i class='fa fa-plus-square'></i> Sick"

							if (isOnVacation)
								item.clockStatus = "<i class='fa fa-plane'></i> Vacation"

						}

						if (!isSick && !isOnVacation)
							item.clockStatus = "<i class='fa fa-bed fa-2x' style='color:#e0e0e0;'></i>"
					}
				}

				item.linkedPhone = ""
				if (item.phone_mobile != "")
					item.linkedPhone = "<a href='tel:"+item.phone_mobile+"'>m: "+item.phone_mobile+"</a>"

				if (item.phone != "")
					item.linkedPhone += " <a href='tel:"+item.phone+"'>h: "+item.phone+"</a>"

				item.linkedEmail = "<a href='mailto:"+item.email+"'>"+item.email+"</a>";

				item.callButton = "<a href='tel:"+item.phone+"'><i class='fa fa-phone fa-2x' style='color:green'></i></a>";

				item.classificationName = ""
				if ("EmployeeClassification" in item && item.EmployeeClassification.length > 0)
					item.classificationName = item.EmployeeClassification[0].title

				item.roleType = ""
				item.formerEmployee = null
				if ("UserPermission" in item && item.UserPermission && item.UserPermission.length > 0) {
					item.roleType = item.UserPermission[0].role_type

					if (item.UserPermission[0].is_inactive == 1) {
						item.formerEmployee = true
						item.rowClasses = "table-secondary"
					}
				}

				return item

			})

			return employees
		},

	tableFields() {

		if (!this.isFullTable) {
			return [
				{label: "Name", key: "fullName", type: "link"},
				{label: "Email", key: "linkedEmail", showOnMobile: false},
				{label: "Phone", key: "linkedPhone", showOnMobile: false},
			]
		}

		return [
			{label: "", key: "isOnline"},
			{label: "Name", key: "fullName", type: "link"},
			{label: "Email", key: "linkedEmail", showOnMobile: false},
			{label: "Phone", key: "linkedPhone", showOnMobile: false},
			{label: "Classification", key: "classificationName", showOnMobile: false},
			{label: "Emergency Contact", key: "emergencyContactDetails", showOnMobile: false},
			{label: "Status", key: "clockStatus"},
			{label: "Ex", key: "formerEmployee", type: "boolean"},
			{label: "Role", key: "roleType"}
		]

	},

	tableButtons() {
	  if (this.isFullTable) {
		return this.buttonsFilteredForPerms()
	  }
	  return [
		{
		  class: "btn-primary",
		  click: "resendInvite",
		  icon: "fa-paper-plane",
		  title: "Resend invite",
		  text: "Resend Invite"
		}
	  ]
	}
	},
	methods: {
		pageChange(page) {
			this.page = page
			this.fetchTableData()
		},
		showUserClockedInMap() {
			let vm = this

			vm.mapModalVisible = true
			vm.mapModalWorking = true


			let params = {
				include: [
					{model: "User",fields:["id","first_name","last_name"]},
					{model: "Job",fields: ["id","slug","job_name","job_num"]},
					{model: "Service",fields: ["id","slug","job_name","job_num"]}
				]
			}

			this.getJSON("OpenTimeLog/get",params).then(response => {
				if (response.success) {
					vm.clockedInUsers = response.data.map(log => {
						let user = vm.cloneObj(log.User)
						delete log.User

						user.OpenTimeLog = log

						return user
					})

					vm.mapModalWorking = false
				}
			})
		},
		syncQBOData() {
			let vm = this

			let payload = {
				overwrite_details: 0
			}

			if (this.syncQBOModal.overwriteDetails)
				payload.overwrite_details = 1

			this.syncQBOModal.working = true

			this.postData("QuickbooksConnection/sync-employees",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess(response.data.added+" employees added to Quickbooks")
					vm.syncQBOModal.visible = false
				}
				vm.syncQBOModal.working = false
			})
		},
	buttonsFilteredForPerms() {
	  return this.filterNavForPerms(this.buttons)
	},

	fetchActiveCount() {
		  // Fetch the number of active employees and store the result
	  // Effects: updates this.activeEmployeeCount

	  let params = {
		filters: [
		  ["invite_accepted !=", null],
		  ["invite_accepted !=", 0],
		  ["invite_declined", 0],
		  ["disconnect_date", null]
		],
		fields: ["invite_accepted", "invite_declined", "is_inactive"],
		count: true
	  }

	  this.getJSON("UserPermission/get", params).then(response => {
		if (response.success) {
		  this.activeEmployeeCount = response.count
		}
	  })


	},

	fetchInvitedCount() {
	  // Fetch the number of invited employees and store the result
	  // Effects: updates this.invitedEmployeeCount

	  let params = {
		filters: this.invitedFilters,
		fields: this.invitedFields,
		count: true
	  }

	  this.getJSON("UserPermission/get", params).then(response => {
		if (response.success) {
		  this.invitedEmployeeCount = response.count
		}
	  })
	},

	fetchTableData() {
		  if (this.tableTab == 'invites') {
		this.fetchInvites()
		this.isFullTable = false
	  } else {
		this.fetchEmployees()
		this.isFullTable = true
	  }
	},

	fetchInvites() {
		  // Fetches all employees that are invited, but have not
	  // accepted/declined the offer yet.  Stores the result in
	  // $store.employees to be accessed by the table

	  let vm = this

	  this.spinner(true)
	  this.loading = true

	  let payload = {
		include: this.invitedInclude,
		fields: this.invitedFields,
		filters: this.invitedFilters
	  }

	  this.getJSON("UserPermission/get",payload).then(function(response) {
		if (response.success) {

		  if (vm.tableTab === 'invites') {
			vm.$store.employees  = response.data.map(userPerm => {
			  let user = vm.cloneObj(userPerm.User)
			  delete userPerm.User
			  user.UserPermission = userPerm
			  return user
			})
			vm.userCount = response.data.length
			vm.pages = 1
		  }
		}
		vm.spinner(false)
		vm.loading = false
	  })
	},

		fetchEmployees() {

		  // Fetches the data for employees, and updates the table
	  // Uses:  userInclude, userFields, page
	  // Updates:  spinner, loading, pages, userCount, $store.employees
			let vm = this

			this.spinner(true)
			this.loading = true

			let payload = {
				//company_id: this.$store.userDetails.tenant_id,
				include: this.userInclude,
				fields: this.userFields,
				page: this.page
			}

			if (this.tableTab == 'all')
				payload.includeFormer = true

			this.getJSON("User/get",payload).then(function(response) {
				if (vm.tableTab !== 'invites') {
					vm.$store.employees = response.data

					vm.pages = response.meta.num_pages
					vm.userCount = response.meta.num_results
				}
				vm.spinner(false)
				vm.loading = false
			})	

		},
		searchEmployees(terms){
		  // Fetches employees based on user-provided parameters, then
	  // updates the table
	  // Uses: userInclude, userFields
	  // Updates: spinner, loading, pages, userCount, $store.employees
			let vm = this

			terms = encodeURIComponent(terms)

			vm.spinner(true)

			let filters = []

			//if terms are separate by a space, assume first and last name
			if (terms.indexOf(" ") >= 0) {
				let names = terms.split(" ")

				filters = [
					['first_name',names[0],"and","like"],
					['last_name',names[names.length-1],"and","like"]
				]
			}
			else {
				filters = [
					["first_name",terms,"and","like"],
					["last_name",terms,"or","like"],
					["email",terms,"or","like"]
				]
			}

			let payload = {}

			if (this.tableTab == 'invites') {
				payload.include = this.invitedInclude
				payload.filters = filters.concat(this.invitedFilters)
				payload.fields = this.invitedFields
			}
			else {
				payload.include = this.userInclude
				payload.filters = filters
				payload.fields = this.userFields
			}

			if (this.tableTab == 'all')
				payload.includeFormer = true

			if (this.tableTab == 'invites') {
				vm.getJSON("UserPermission/get",payload).then(response => {
					vm.$store.employees = response.data.map(userPerm => {
						let user = vm.cloneObj(userPerm.User)
						delete userPerm.User
						user.UserPermission = userPerm
						return user
					})
				})
			}
			else {
				vm.getJSON("User/get",payload).then(response => {
					vm.$store.employees = response.data
				})
			}
			vm.pages = 0
			vm.spinner(false)

		},
		otherButtonClick(record,action) {
			this[action](record);
		},
		mailUser(record) {
			this.$bus.$emit("newThread",false,false,false,[record.id])
		},
		phoneUser(record) {
			if (record.phone_mobile) 
				document.location.href = "tel:"+record.phone_mobile
			
			else if (record.phone) 
				document.location.href = "tel:"+record.phone
			
			else
				this.alertFail("No phone numbers listed")
		},
		resendInvite(user) {
			let vm = this

			vm.postData("CompanyUser/offer-employment",{user_id:user.id},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Connection invite re-sent!")
				}
			})
		},
		searchSubmit(terms) {
			if  (terms != "")
				this.searchEmployees(terms)
			else
				this.fetchTableData()
		}
	},
	destroyed() {
		this.$bus.$off("searchUsers")
	},
	created() {
		this.fetchEmployees()
		this.fetchCompanyData(false,["CompanySetting"])
		this.fetchActiveCount()
		this.fetchInvitedCount()

		this.$set(this.$store,"employees",[])		
	}

}
</script>

<style type="text/css">
	.online-circle {
		color: limegreen;
	}
</style>